import { render, staticRenderFns } from "./FrontIntegrationSettings.vue?vue&type=template&id=2c695122&"
import script from "./FrontIntegrationSettings.vue?vue&type=script&lang=js&"
export * from "./FrontIntegrationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports